import { blockCategories } from '../../../categories';

export default (editor) => {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    blockManager.add('container').set({
        label: 'Login-Modal öffnen',
        category: blockCategories.basic,
        content: {
            type: 'login-modal',
            classes: ['login-modal'],
        },
        media: `
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 17L12 19L17 14L12 9L10 11L12.59 13.5H4V15.5H12.59L10 17Z" fill="currentColor"/>
            <path d="M20 3H12C10.9 3 10 3.9 10 5V8H12V5H20V19H12V16H10V19C10 20.1 10.9 21 12 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3Z" fill="currentColor"/>
            </svg>
        `,
    });

    const defaultType = domComponents.getType('default');
    const defaultModel = defaultType.model;
    const defaultView = defaultType.view;

    domComponents.addType('login-modal', {
        model: {
            defaults: Object.assign({}, defaultModel.prototype.defaults, {
                'custom-name': 'Login-Modal',
                tagName: 'div',
                droppable: true,
            }),
        },
        isComponent(el) {
            if (el && el.classList && el.classList.contains('login-modal')) {
                return { type: 'login-modal' };
            }
        },
        view: defaultView,
    });
};
